/**
 * @prettier
 * @author Alexander Nagelberg
 *
 * Like LgyInputField but special for files. File inputs cannot cede the same control
 * to redux-form so this cuts to barebones.
 *
 * Use it the same way as LgyInputField as a component in <Field /> (maybe disable format to be safe)
 * @example
 * <Field label='File' name='file' component={LgyFileInputField} format={null} required />
 *
 * */
import React from 'react'

const LgyFileInputField = ({
  input: { onChange, name, value },
  meta: { error, dirty },
  id,
  label,
  accept,
  customClass,
  disabled
}) => {
  return (
    <div className={dirty && error ? 'usa-input-error lgy-input-field' : 'lgy-input-field'}>
      {dirty && error && (
        <span className='usa-input-error-message' id={`${id}-error`} role='alert'>
          {error}
        </span>
      )}
      <label htmlFor={id}>{label}</label>
      <input
        type='file'
        disabled={disabled}
        accept={accept}
        className={customClass}
        name={name}
        id={id}
        value={value ? undefined : ''}
        onChange={e => onChange(e.target.files[0])}
        required
      />
    </div>
  )
}

export default LgyFileInputField
